module.exports = __webpack_public_path__ + "static/media/aluraQuiz.4ef9c3cb.JPG";